/* eslint-disable react-hooks/exhaustive-deps */
/*
 * Author M. Atoar Rahman
 * Title: Requisition DataTable
 * Description: Requisition DataTable
 * Date: 28/06/2022
 */

import { toArray } from 'lodash';
import { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import useDataTable from '../../../hooks/useDataTable';
import { usePartnerStockDistribution } from './ContextAPI';

export default function RequisitionTable({ data }) {
    const { setReceiveList, receiveData, setReceiveData } = usePartnerStockDistribution();

    const requisitionRowHandler = (value, item) => {
        const itemdata = { ...item, supplied_qty: value };
        const list = { ...receiveData };
        list[itemdata.drug_id] = itemdata;
        if (value === '') {
            delete list[itemdata.drug_id];
        }
        setReceiveData(list);
    };

    // Object to Array Convart
    useEffect(() => {
        const arrOfObj = toArray(receiveData);
        setReceiveList(arrOfObj);
    }, [receiveData]);

    const conditionalCellStyles = [
        {
            when: (row) => Number(row.available_qty) <= 0,
            style: {
                backgroundColor: '#ffb4c1',
            },
        },
        {
            when: (row) =>
                Number(row.available_qty) > 0 &&
                Number(row.available_qty) < Number(row.approved_request_qty),
            style: {
                backgroundColor: '#ffb4c1',
            },
        },
        {
            when: (row) =>
                Number(row.available_qty) > 0 &&
                Math.floor(Number(row.avg_monthly_consumption)) < Number(row.approved_request_qty),
            style: {
                backgroundColor: '#fcff3c',
            },
        },
    ];

    const columns = [
        {
            name: 'Item Name',
            selector: (row) => row.drug_name,
            sortable: true,
            width: '350px',
            wrap: true,
            conditionalCellStyles,
        },
        {
            name: 'Opening Balance',
            selector: (row) => row.opening_balance,
            sortable: true,
            conditionalCellStyles,
        },
        {
            name: 'Closing Balance',
            selector: (row) => row.closing_balance,
            sortable: true,
            conditionalCellStyles,
        },
        {
            name: 'Avg Monthly Consumption',
            selector: (row) => row.avg_monthly_consumption,
            sortable: true,
            conditionalCellStyles,
        },
        {
            name: 'Request Quantity',
            selector: (row) => row.approved_request_qty,
            sortable: true,
            conditionalCellStyles,
        },
        {
            name: 'Available Quantity',
            selector: (row) => row.available_qty,
            sortable: true,
            conditionalCellStyles,
        },
        {
            name: 'Distribution Quantity',
            selector: (row) => row.supplied_qty,
            cell: (row) => (
                <Form.Control
                    key={row.drug_id}
                    size="sm"
                    type="number"
                    value={receiveData?.[row.drug_id]?.supplied_qty ?? ''}
                    onChange={(e) => {
                        requisitionRowHandler(e.target.value, row);
                    }}
                />
            ),
            reorder: true,
            conditionalCellStyles,
        },
    ];

    const search_column = {
        drug_name: 'Name',
    };
    return useDataTable({ columns, data, search_column, pagination: false });
}
